import React from "react";

const Block = props => (

<div className="flex flex-col h-full w-full msb
md:flex-row md:h-auto">

  <div className="pt-1 pb-2 txtbody leading-loose font-bold
  md:w-2/5 md:leading-normal">
    <p>{props.blockh2}</p>
  </div>

  <div className="txtbody leading-normal font-normal msb
  md:mb-0 md:w-3/5 md:pt-1 md:pr-2">
    <p>{props.blockp}</p>
  </div>

</div>

);

export default Block;


// WEBPACK FOOTER //
// ./src/components/TextFullPage/block.js